<template>
  <div>
    <Dialog
      :key="tableKey"
      :visible.sync="duplicateDialog1"
      :style="{ width: '1000px', overflowY: 'auto' }"
      :header="'Duplicate ' + namePlural"
      :modal="true"
      class="p-fluid"
    >
      The following {{ namePlural }} seems to be duplicates of the
      {{ name }} you are trying to save. Please confirm if you wish to still
      save this {{ name }}?

      <DataTable
        :value="list"
        :paginator="true"
        :dataKey="dataId"
        class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-opportunities"
        :rows="50"
        :rowHover="true"
        :selection.sync="selected"
        :loading="loading"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[25, 50, 100]"
        currentPageReportTemplate="{first} to {last} of {totalRecords} Enquiries"
      >
        <template #empty> No {{ namePlural }} found. </template>
        <template #loading>
          Loading {{ namePlural }} data. Please wait.
        </template>
        <Column
          headerStyle="width: 4em"
          field="sim_desc_rank"
          header="Sim. Desc %"
          :sortable="true"
        >
          <!-- :style="'color: ' + getColors(slotProps.data.rank) + ';'" -->
          <template #body="slotProps">
            <div>
              <Button
                :label="
                  slotProps.data.sim_desc_rank
                    ? Math.round(slotProps.data.sim_desc_rank * 100).toString()
                    : ''
                "
                :class="
                  'p-button-sm p-button-rounded p-button-' +
                    getColors(slotProps.data.sim_desc_rank)
                "
              />
              <!-- <Badge 
                :severity="getColors(slotProps.data.sim_desc_rank)"
                style="width: 5px;" 
                :value="slotProps.data.sim_desc_rank ? Math.round(slotProps.data.sim_desc_rank * 100) : ''" 
                class="p-mr-2"
              ></Badge> -->
            </div>
          </template>
        </Column>
        <Column
          headerStyle="width: 4em"
          field="sim_addr_rank"
          header="Sim. Addr %"
          :sortable="true"
        >
          <!-- :style="'color: ' + getColors(slotProps.data.rank) + ';'" -->
          <template #body="slotProps">
            <div>
              <Button
                v-if="slotProps.data.sim_addr_rank"
                :label="
                  slotProps.data.sim_addr_rank
                    ? Math.round(slotProps.data.sim_addr_rank * 100).toString()
                    : ''
                "
                :class="
                  'p-button-sm p-button-rounded p-button-' +
                    getColors(slotProps.data.sim_addr_rank)
                "
              />
              <!-- <Badge 
                :severity="getColors(slotProps.data.sim_addr_rank)"
                style="width: 5px;" 
                :value="slotProps.data.sim_addr_rank ? Math.round(slotProps.data.sim_addr_rank * 100) : ''" 
                class="p-mr-2"
              ></Badge> -->
            </div>
          </template>
        </Column>
        <Column
          v-for="(col, index) of colSelectedFieldsForTable"
          :key="col.dbField + '_' + index"
          :header="col.fieldName"
          :sortable="true"
          :headerStyle="'width: ' + col.defWidth + 'px;'"
          v-if="col.dbField != 'status'"
        >
          <template #body="slotProps">
            <div>
              {{ getToShow(slotProps.data, col) }}
            </div>
          </template>
        </Column>
        <Column
          header="Status"
          :sortable="true"
          headerStyle="width: 10em;"
          sortField="opportunityStatus.oppStatusCode"
          filterField="opportunityStatus.oppStatusCode"
        >
          <template #body="slotProps">
            <span :class="'ignore pointer badge ' + getStyle(slotProps.data)">
              {{
                slotProps.data.opportunityStatus
                  ? slotProps.data.opportunityStatus.oppStatusName
                  : slotProps.data.oppStatusName
              }}
            </span>
          </template>
        </Column>
        <Column headerStyle="width: 3em">
          <template #body="slotProps">
            <Button
              icon="pi pi-search"
              class="p-button-rounded p-button-success p-button-text"
              f
              @click="showDetails(slotProps.data)"
            />
            <OverlayPanel
              ref="filters2"
              appendTo="body"
              :showCloseIcon="true"
              id="quickFilters"
              style="width: 750px"
            >
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">Enq Id</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{ item.oppId }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">Country</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{ item.country }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">Quote No.</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{ item.sQuoteNo }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">Full Address</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{ item.address }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">Description</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{ item.oppDescription }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">Phone No.</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{ item.phoneNo }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">Date Rcvd.</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{ item.dateReceived }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">Email</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{ item.email }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">Branch</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{
                    item.mbpBranch
                      ? item.mbpBranch.branchName
                      : item.mbpBranchName
                  }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">Region</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{
                    item.region ? item.region.regionName : item.regionName
                  }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">Customer</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{
                    item.customer ? item.customer.custName : item.custName
                  }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">Sales Exec.</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{
                    item.salesExec
                      ? item.salesExec.salesExecName
                      : item.salesExecName
                  }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">Contact</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{
                    item.contact ? item.contact.contactName : item.contactName
                  }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">Requested By</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{
                    item.requestedBy ? item.requestedBy.fullName : ""
                  }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">Product Type</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{
                    item.productType
                      ? item.productType.productTypeName
                      : item.productTypeName
                  }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">ABI No.</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{ item.abiNo }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">Project Type</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{
                    item.projectType
                      ? item.projectType.projTypeName
                      : item.projTypeName
                  }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">Customer Ref.</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{ item.custRef }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">Enq. Status</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{
                    item.opportunityStatus
                      ? item.opportunityStatus.statusName
                      : item.statusName
                  }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">Notes</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{ item.notes }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">Home</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{ item.address1 }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">Last Task/Event Dt.</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{ item.lastActivityDate }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">Street</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{ item.address2 }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">Date Created</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{ item.dateCreated }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">Sub Area</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{ item.address3 }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">Created By</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{
                    item.createdBy ? item.createdBy.fullName : item.fullName
                  }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">City/Town</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{ item.address4 }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">Date Updated</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{ item.dateUpdated }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col col-lg-2 md-3">
                  <label class="label">Post Code</label>
                </div>
                <div class="col col-lg-5 md-3">
                  <span class="data">{{ item.postCode }}</span>
                </div>
                <div class="col col-lg-2 md-3">
                  <label class="label">Updated By</label>
                </div>
                <div class="col col-lg-3 md-3">
                  <span class="data">{{
                    item.updatedBy ? item.updatedBy.fullName : ""
                  }}</span>
                </div>
              </div>
            </OverlayPanel>
          </template>
        </Column>
        <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
      </DataTable>

      <template #footer>
        <Button
          style="float: left;"
          @click="showSelected()"
          label="Show details"
        />
        <Button
          v-if="disabledArr.includes('buttons')"
          @click="$emit('close')"
          label="Okay"
        />
        <Button
          v-if="!disabledArr.includes('buttons')"
          @click="$emit('close')"
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
        />
        <div v-if="!disabledArr.includes('buttons')" style="display: inline;">
          <ProgressSpinner
            v-if="requesting"
            style="width:25px; height:25px; width: 100px;"
            strokeWidth="5"
            fill="#EEEEEE"
            animationDuration=".5s"
          />
          <Button
            v-else
            @click="$emit('agree')"
            label="Save"
            icon="pi pi-check"
            autofocus
          />
        </div>
      </template>
    </Dialog>

    <duplicateDialog
      :name="name"
      :namePlural="namePlural"
      :duplicateDialog="displayDuplicateMessage"
      :duplicates="duplicates"
      @close="displayDuplicateMessage = false"
    />
  </div>
</template>

<script>
import duplicateDialog from "../duplicate/duplicateDialog";

export default {
  components: {
    duplicateDialog
  },
  props: {
    duplicateDialog: {
      type: Boolean,
      required: true
    },
    list: {
      type: Array,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    namePlural: {
      type: String,
      required: false
    },
    colSelectedFieldsForTable: {
      type: Array,
      required: true
    },
    dataId: {
      type: String,
      required: true
    },
    disabledArr: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    requesting: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    displayDuplicateMessage: false,
    selected: [],
    duplicates: [],
    tableKey: 0,
    item: {}
  }),
  computed: {
    duplicateDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.duplicateDialog;
      }
    },
    loading() {
      return this.list ? false : true;
    }
  },
  watch: {
    duplicateDialog(val) {
      this.tableKey++;
    },
    list(val) {
      this.tableKey++;
    }
  },
  methods: {
    showDetails(data) {
      this.item = data;
      this.$refs.filters2.toggle(event);
    },
    getColors(data) {
      let rank = data * 100;
      if (rank) {
        if (rank < 40) {
          return "secondary";
          // return 'Grey'
        } else if (rank >= 40 && rank < 55) {
          return "info";
          // return 'Blue'
        } else if (rank >= 55 && rank < 70) {
          return "help";
          // return 'Yellow'
        } else if (rank >= 70 && rank < 85) {
          return "warning";
          // return 'Orange'
        } else if (rank >= 90 && rank <= 100) {
          return "danger";
          // return 'Red'
        } else {
          return "danger";
          // return 'Black'
        }
      }
    },
    getToShow(data, col) {
      let a = col.dbField.split(".");

      if (a.length > 1) {
        return data[a[0]] ? data[a[0]][a[1]] : "";
      } else if (col.dbField == "updatedBy" || col.dbField == "createdBy") {
        if (data[col.dbField] && data[col.dbField]["fullName"])
          return data[col.dbField]["fullName"];
        else return "-";
      } else if (col.dbField == "userId") {
        if (data["oppId"]) return data["oppId"];
        else return "-";
      } else if (col.dbField == "userName") {
        if (data["oppDescription"]) return data["oppDescription"];
        else return "-";
      } else if (col.dbField == "branchCode") {
        if (data["mbpBranchCode"]) return data["mbpBranchCode"];
        else return "-";
      } else {
        return data[col.dbField];
      }
    },
    showSelected() {
      if (!(this.selected && this.selected.length)) {
        this.$toast.add({
          severity: "warn",
          summary: "Warning",
          detail: "Please select some " + this.namePlural,
          life: 5000
        });
      } else {
        this.displayDuplicateMessage = true;
        this.duplicates = this.selected;
      }
    },
    getStyle(data) {
      // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (data && data.opportunityStatus) {
        data = data.opportunityStatus;
      }

      if (data) {
        if (data.colourCode) {
          return data.colourCode;
        } else if (
          data.oppStatusName &&
          data.oppStatusName.toLowerCase() === "active"
        ) {
          return "badge-primary";
        } else if (
          data.oppStatusName &&
          data.oppStatusName.toLowerCase() === "lost"
        ) {
          return "badge-danger";
        } else if (
          data.oppStatusName &&
          data.oppStatusName.toLowerCase() === "otp"
        ) {
          return "badge-light";
        } else if (
          data.oppStatusName &&
          data.oppStatusName.toLowerCase() === "new"
        ) {
          return "badge-info";
        } else if (
          data.oppStatusName &&
          data.oppStatusName.toLowerCase() === "cancelled"
        ) {
          return "badge-secondary";
        } else if (
          data.oppStatusName &&
          data.oppStatusName.toLowerCase() === "won"
        ) {
          return "badge-success";
        } else if (
          data.oppStatusName &&
          data.oppStatusName.toLowerCase() === "tender"
        ) {
          return "badge-warning";
        } else {
          return "badge-dark";
        }
      } else {
        return "badge-dark";
      }
    }
  }
};
</script>

<style>
.label {
  color: black;
}

.data {
  color: blue;
}
</style>
